<template>
  <WdsText class="tw-text-right">
    {{ column.currency }} {{ column.rate }}
    <br />
    {{ column.hasMilestones ? 'milestones' : column.rateType }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const RateColumn = graphql(`
  fragment RateColumnHire on Hire {
    rate
    rateType
    currency
    hasMilestones
  }
`)

const props = defineProps<{ row: FragmentType<typeof RateColumn> }>()
const column = computed(() => useFragment(RateColumn, props.row))
</script>
